import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const ReadContent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 19" {...props}>
    <g clipPath="url(#a)">
      <path d="M23.5 4.105c-.107.46-.206.924-.487 1.317-.19.266-.404.516-.597.76-1.526-1.527-3.023-3.024-4.536-4.535.489-.55 1.108-.936 1.87-1.054 1.834-.283 3.409.864 3.711 2.687.007.036.026.069.039.104v.722ZM7.45 12.125l9.403-9.406c1.484 1.485 2.986 2.988 4.485 4.485l-9.406 9.403-4.482-4.482ZM6.599 13.408l4.03 4.03c-.406.094-.827.191-1.247.285-.908.204-1.816.407-2.725.605a2.07 2.07 0 0 1-.424.05c-1.675.003-3.352.003-5.027 0-.112 0-.228-.008-.333-.04a.687.687 0 0 1-.471-.715.685.685 0 0 1 .586-.622c.103-.015.21-.018.314-.018 1.42 0 2.84-.005 4.26.005.194.002.255-.065.293-.24.241-1.114.493-2.225.742-3.341l.002.001Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M.4.55h23.1v17.831H.4z" />
      </clipPath>
    </defs>
  </svg>
);
export default ReadContent;
